<template>
    <Tooltip
        v-if="userInfoLoaded && isAuthorized"
        ref="tooltipRef"
        :content="tr('gameContainer.logged_in_tooltip')"
        :showOnMobile="true"
    >
        <RoundButton
            icon="happy-cloud"
            interfaceTarget="game-container-login-button"
            :class="$style.button_green_override"
            @click="showLoggedInTooltip"
        />
    </Tooltip>

    <RoundButton
        v-else-if="userInfoLoaded && !isAuthorized"
        icon="sad-cloud"
        interfaceTarget="game-container-login-button"
        :class="$style.button_red_override"
        @click="layoutStore.openSignInModal('game-mobile-footer-login-button')"
    />

    <RoundButton
        v-else
        :icon="undefined"
        interfaceTarget=""
    />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { ref, useCssModule } from 'vue'

import Tooltip from '@/components_new/Tooltip/Tooltip.vue'
import { useTr } from '@/composables/use-tr'
import { useUserInfoLoaded } from '@/composables/use-user-state'
import { useLayoutStore } from '@/store/layout-store'
import { useUserStore } from '@/store/user-store/user-store'

import RoundButton from './RoundButton.vue'

const $style = useCssModule()
const layoutStore = useLayoutStore()

const userInfoLoaded = useUserInfoLoaded()
const userStore = useUserStore()
const { isAuthorized } = storeToRefs(userStore)
const tr = useTr()

const tooltipRef = ref<InstanceType<typeof Tooltip> | null>(null)

function showLoggedInTooltip() {
    tooltipRef.value?.showTooltip()
    setTimeout(() => {
        tooltipRef.value?.hideTooltip()
    }, 2000)
}
</script>

<style module>
.button_red_override {
    --background-color: rgba(255, 156, 156, 0.24);
    color: var(--rose-400);
}

.button_green_override {
    --background-color: rgba(192, 255, 71, 0.16);
    color: var(--electric-lime);
}
</style>
